import React from 'react'

export const PlusIcon = ({
    fill = '#272727',
    width = '28',
    height = '28',
}: {
    fill?: string
    width?: string
    height?: string
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5 10H15M10 15L10 5"
            stroke={fill}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
